export default "__VITE_ASSET__CC4yYEpB__"